import React, {Component} from 'react';
import { FilePond, registerPlugin } from 'react-filepond'
import 'filepond/dist/filepond.min.css';

import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginFilePoster, FilePondPluginFileValidateType)

export class CustomFileUpload extends Component {

    constructor() {
        super();

        this.onMessage = this.onMessage.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeFiles = this.onChangeFiles.bind(this);
        this.onAddFileStart = this.onAddFileStart.bind(this);

        this.state = { fileValue: [] };
    }

    onMessage(msg) {
        if (this.props.onMessage)
            this.props.onMessage(msg);
    }

    onChange(value) {
        if (this.props.onChange)
            this.props.onChange(value);
    }    
    
    onChangeFiles(value) {
        if (this.props.onChangeFiles)
            this.props.onChangeFiles(value);
    }

    onAddFileStart(value) {
        if (this.props.onAddFileStart)
            this.props.onAddFileStart(value);
    }

    render() {
        return  <FilePond
                    allowMultiple={this.props.allowMultiple === false ? false : true}
                    disabled={this.props.disabled}
                    acceptedFileTypes={this.props.acceptedFileTypes || []}
                    server={{
                        url: `${process.env.REACT_APP_API_URL}/file/upload/${this.props.sessionId}`,
                        revert: null,
                        restore: null,
                        load: null,
                        fetch: null,
                        headers: {
                            Authorization: `Bearer ${this.props.token}`
                        },
                    }}
                    labelIdle={this.props.placeholderText || "Drag & Drop your files or <span class='filepond--label-action'> Browse </span>"}
                    files={this.props.fileValue}
                    onerror={(err, file, status) => {
                        this.onMessage({severity: 'error', summary: 'Error', detail: status.main});
                    }}
                    onremovefile={(e, file) => {
                        if (this.props.onRemove)
                            this.props.onRemove(file);
                    }}
                    onaddfilestart={(file) => {
                        if (this.props.onStart)
                            this.props.onStart();

                        this.onAddFileStart(file);
                    }}
                    onupdatefiles={(fileItems) => {
                        this.onChangeFiles(fileItems.map(fileItem => fileItem.file));
                    }}
                    onprocessfile={(err, file) => {
                        if (this.props.onFinish)
                            this.props.onFinish();

                        if (err) {
                            console.error(err);
                            return;
                        }

                        var sData = JSON.parse(file.serverId);

                        let fi = {
                            url: sData.url,
                            file: {
                                name: file.source.name,
                                type: file.source.type,
                                size: file.source.size,
                            },
                            extraInfo: sData.extraInfo || null,
                        };
                        this.onChange(JSON.stringify(fi));
                    }}
                />;
    }
}